/* eslint-disable camelcase */
import PropTypes from 'prop-types'

export const iaeauResultsShape = PropTypes.shape({
    graphe_thermometre: PropTypes.shape({
        besoin_total_estime: PropTypes.number,
        volume_couvert: PropTypes.number,
        pourcentage_couvert: PropTypes.number,
    }),
    indicateurs_synthetiques: PropTypes.shape({
        couv_besoins: PropTypes.number,
        ecart_conso: PropTypes.number,
        pct_vp_consomme: PropTypes.number,
    }),
    prelevements_observes: PropTypes.arrayOf(PropTypes.shape({
        irrig_observe: PropTypes.number,
        jour: PropTypes.number,
        p80_obs: PropTypes.number,
    })),
    prelevements_projections: PropTypes.arrayOf(PropTypes.shape({
        jour: PropTypes.number,
        p10: PropTypes.number,
        p20: PropTypes.number,
        p50: PropTypes.number,
        p80: PropTypes.number,
        p90: PropTypes.number,
        ymax: PropTypes.number,
        ymin: PropTypes.number,
    })),
})

export const linkStationDetailsShape = PropTypes.shape({
    idStation: PropTypes.number.isRequired, // Int,
    name: PropTypes.string, // Option[String],
    code: PropTypes.string, // Option[String],
    lastLandmark: PropTypes.number, // Option[Double], repère de la station
    groundRefAlti: PropTypes.number, // Option[Double], altitude du sol
    dataType: PropTypes.number.isRequired, // Int, // -1 -> Profondeur / 4 -> Hauteur / 5 -> Débit
    lastMeasure: PropTypes.number, // Option[Double],
    NGFLastMeasure: PropTypes.number, // Option[Double],
    measures: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired, // Seq[Seq[Option[Double]]], [date, value, (NGFValue)]
    dryTriennial: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired, // Seq[Seq[Option[Double]]], [date, value, (NGFValue)]
    dryQuadrennial: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired, // Seq[Seq[Option[Double]]], [date, value, (NGFValue)]
    dryQuinquennial: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired, // Seq[Seq[Option[Double]]], [date, value, (NGFValue)]
})